
export class PioneerUtils {
  static getLastElement(elements: any[]) {
    return elements && elements.length > 0 ? elements[elements.length - 1] : null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/pioneer-utils.ts